import template from './skeleton.html' with { type: 'html' };

export default {
	name: 'CSkeleton',
	props: {
		element: {
			type: String,
			default: 'div'
		},
		show: {
			type: Boolean,
			default: true
		}
	},
	template
};
